import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Radio, LogOut, User, LayoutDashboard, Webhook, ShieldCheck, MailQuestion } from "lucide-react";

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navItem = (to, label, Icon) => {
    const active = location.pathname === to;
    const locked = user?.locked && to !== "/credits";
    if (locked) {
      return (
        <span
          data-testid={`nav-${label.toLowerCase()}`}
          title="Add credits to unlock"
          className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground/40 cursor-not-allowed select-none"
        >
          <Icon className="w-4 h-4" />
          {label}
        </span>
      );
    }
    return (
      <button
        onClick={() => navigate(to)}
        data-testid={`nav-${label.toLowerCase()}`}
        className={`flex items-center gap-2 px-3 py-2 text-sm transition-colors duration-200 ${
          active ? "text-white" : "text-muted-foreground hover:text-white"
        }`}
      >
        <Icon className="w-4 h-4" />
        {label}
      </button>
    );
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border">
        <div className="flex items-center justify-between px-6 h-16">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
              <div className="w-8 h-8 bg-[#007AFF] flex items-center justify-center">
                <Radio className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-black text-lg tracking-tighter">Incident Tracking &amp; Inquiry Services</span>
            </div>
            <nav className="hidden md:flex items-center gap-1">
              {navItem("/", "Dashboard", LayoutDashboard)}
              {navItem("/inquiries", "Inquiries", MailQuestion)}
              {user?.role === "admin" && navItem("/webhook", "Connect", Webhook)}
              {navItem("/profile", "Profile", User)}
              {user?.role === "admin" && navItem("/admin", "Admin", ShieldCheck)}
            </nav>
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm font-medium">{user?.name || "User"}</span>
              <span className="text-xs text-muted-foreground font-mono">{user?.email}</span>
            </div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="w-9 h-9 flex items-center justify-center border border-border text-muted-foreground hover:text-white hover:border-white transition-colors duration-200"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 flex flex-col">{children}</main>
    </div>
  );
};
